import { cn } from '@/lib/utils';
import { Lightbulb } from 'lucide-react';

// Tez (Thesis) Box - Shows the main takeaway at the start of an article
export const TezBox = ({ children, className }) => {
  return (
    <aside 
      className={cn(
        "relative my-8 p-6 bg-accent/5 border-l-4 border-accent rounded-r-sm",
        className
      )}
      role="complementary"
      aria-label="Yazının tezi"
    >
      {/* Label */}
      <div className="absolute -top-3 left-4 flex items-center gap-1.5 px-2 bg-background">
        <Lightbulb className="h-3.5 w-3.5 text-accent" />
        <span className="text-xs font-semibold tracking-widest uppercase text-accent">
          Tez
        </span>
      </div>
      
      {/* Content */}
      <div className="text-base sm:text-lg leading-relaxed text-foreground font-medium">
        {children}
      </div>
    </aside>
  );
};

// BetweenLines Note - Conclusion/summary note at the end of articles
export const BetweenLinesNote = ({ children, className }) => {
  return (
    <aside 
      className={cn(
        "relative my-10 p-6 bg-muted/50 border border-border rounded-sm",
        className
      )}
      role="complementary"
      aria-label="BetweenLines notu"
    >
      {/* Label */}
      <div className="absolute -top-3 left-4 flex items-center gap-2 px-2 bg-background">
        <div className="flex items-center justify-center w-5 h-5 bg-primary rounded-sm">
          <span className="text-[10px] font-bold text-primary-foreground">BL</span>
        </div>
        <span className="text-xs font-semibold tracking-wider text-muted-foreground">
          BetweenLines Notu
        </span>
      </div>
      
      {/* Content */}
      <div className="text-base leading-relaxed text-muted-foreground italic font-serif">
        {children}
      </div>
    </aside>
  );
};

// Pull Quote - For emphasizing important quotes within articles
export const PullQuote = ({ children, author, className }) => {
  return (
    <blockquote 
      className={cn(
        "my-10 pl-6 border-l-3 border-accent",
        className
      )}
    >
      <p className="font-serif text-xl sm:text-2xl italic leading-relaxed text-muted-foreground">
        "{children}"
      </p>
      {author && (
        <footer className="mt-4 text-sm text-muted-foreground font-sans not-italic">
          — {author}
        </footer>
      )}
    </blockquote>
  );
};

export default TezBox;
